import { render, staticRenderFns } from "./Sliders.vue?vue&type=template&id=150d044d&scoped=true"
import script from "./Sliders.vue?vue&type=script&lang=js"
export * from "./Sliders.vue?vue&type=script&lang=js"
import style0 from "./Sliders.vue?vue&type=style&index=0&id=150d044d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150d044d",
  null
  
)

export default component.exports